/* @flow */

export const TemplateMarketPropertyKeys = {
  ONE_DLC_VIEW_MODE: "oneDlc.viewMode",
  ONE_DLC_SELECTION_MODE: "oneDlc.selectionMode",
  ONE_DLC_INITIAL_LIST_LOAD: "oneDlc.initialListLoad",
  ONE_DLC_INITIAL_FILTER_ACTIVITY_TYPE: "oneDlc.initialFilter.activityType",
  ONE_DLC_INITIAL_FILTER_PRODUCT_GROUP: "oneDlc.initialFilter.productGroup",
  ONE_DLC_INITIAL_SEARCH_FIELD: "oneDlc.initialFilter.search.field",
  ONE_DLC_INITIAL_SEARCH_VALUE: "oneDlc.initialFilter.search.value",
  ONE_DLC_HIDDEN_FIELDS: "oneDlc.hiddenFields",
  ONE_DLC_USE_MARKERS_AVERAGE: "oneDlc.useMarkersAverage",
  ONE_DLC_LIST_DEALERS_RESULTS_PER_REQUEST:
    "oneDlc.listDealers.resultsPerRequest",
  ONE_DLC_LIST_DEALERS_DISABLE_INFINITE_SCROLLING:
    "oneDlc.listDealers.disableInfiniteScrolling",
  DDW_DEALER_IMAGE_FALLBACK_URL: "ddw.dealer.image.fallback.url",
  DDW_DEALER_CONTACT_PERSON_IMAGE_FALLBACK_URL:
    "ddw.dealer.contact.image.fallback.url",
  DSW_SEARCH_RESULTS_VIEW_MODE: "dsw.search.results.view.mode" /* DL-1439 */,
  /* DSW_SEARCH_RESULTS_MAX_COUNT: 'dsw.search.results.maxCount', */ DSW_SEARCH_RESULTS_PAGINATION_PAGE_SIZE:
    "dsw.search.results.pagination.pageSize",
  /* SPA_SEARCH_RESULTS_MAX_COUNT: 'spa.search.results.maxCount', */
  GEN_SEARCH_RADIUS: "generic.search.radius",
  GEN_SEARCH_RADIUS_EXTENDED: "generic.search.radius.extended",
  GEN_SEARCH_RADIUS_DISTANCE_MIN: "generic.search.radius.distanceMin",
  GEN_SEARCH_RADIUS_DISTANCE_MID: "generic.search.radius.distanceMid",
  GEN_SEARCH_RADIUS_DISTANCE_MAX: "generic.search.radius.distanceMax",
  GEN_DISTANCE_UNIT: "generic.distance.unit" /* DL-1468 */,
  GEN_DISTANCE_DELIMITER: "generic.dealer.distance.delimiter",
  GEN_DEALER_NAME_PLACEHOLDER_LINE_1: "generic.dealer.name.placeholder.line1",
  GEN_DEALER_NAME_PLACEHOLDER_LINE_2: "generic.dealer.name.placeholder.line2",
  GEN_DEALER_NAME_PLACEHOLDER_LINE_3: "generic.dealer.name.placeholder.line3",
  GEN_DEALER_ADDRESS_PLACEHOLDER_LINE_1:
    "generic.dealer.address.placeholder.line1",
  GEN_DEALER_ADDRESS_PLACEHOLDER_LINE_2:
    "generic.dealer.address.placeholder.line2",
  GEN_DEALER_ADDRESS_PLACEHOLDER_LINE_3:
    "generic.dealer.address.placeholder.line3",
  GEN_PHONE_DISCLAIMER_LINE_1: "generic.phone.disclaimer.line1",
  GEN_PHONE_DISCLAIMER_LINE_2: "generic.phone.disclaimer.line2",
  GEN_PHONE_DISCLAIMER_LINE_3: "generic.phone.disclaimer.line3",
  GEN_ACTIVITY_TYPE_GROUP_EQC_SALES: "generic.activityType.group.eqc.sales",
  GEN_ACTIVITY_TYPE_GROUP_EQC_AFTER_SALES:
    "generic.activityType.group.eqc.afterSales",
  GEN_ACTIVITY_TYPE_GROUP_REPAIR: "generic.activityType.group.repair",
  GEN_ACTIVITY_TYPE_GROUP_JUNGE_STERNE:
    "generic.activityType.group.jungeSterne",
  GEN_ACTIVITY_TYPE_GROUP_COMMERCIAL_SALES:
    "generic.activityType.group.commercial.sales",
  GEN_ACTIVITY_TYPE_GROUP_PRIVATE_SALES:
    "generic.activityType.group.private.sales",
  GEN_DEALER_PORTFOLIO_ACTIVITY_TYPES_ENABLED:
    "generic.dealer.portfolio.activityTypes.enabled",
  GEN_DEALER_PORTFOLIO_PRODUCT_GROUPS_ENABLED:
    "generic.dealer.portfolio.productGroups.enabled",
  GEN_FILTERS_ACTIVITY_TYPES_ENABLED: "generic.filters.activityTypes.enabled",
  GEN_FILTERS_PRODUCT_GROUPS_ENABLED: "generic.filters.productGroups.enabled",
  GEN_HIGHLIGHTED_ACTIVITY_MAPPING_AMG:
    "generic.activityType.highlighted.icon.amg.mapping",
  GEN_HIGHLIGHTED_ACTIVITY_MAPPING_EQ:
    "generic.activityType.highlighted.icon.eq.mapping",
  GEN_HIGHLIGHTED_ACTIVITY_MAPPING_EQ_CHARGER:
    "generic.activityType.highlighted.icon.eqCharger.mapping",
  GEN_HIGHLIGHTED_ACTIVITY_MAPPING_PARTS_PRO:
    "generic.activityType.highlighted.icon.partsPro.mapping",
  GEN_HIGHLIGHTED_ACTIVITY_MAPPING_WEBPARTS:
    "generic.activityType.highlighted.icon.webParts.mapping",
  GEN_HIGHLIGHTED_ACTIVITY_MAPPING_JUNGE_STERNE:
    "generic.activityType.highlighted.icon.jungeSterne.mapping",
  GEN_HIGHLIGHTED_ACTIVITY_MAPPING_MB_CERTIFIED:
    "generic.activityType.highlighted.icon.mbCertified.mapping",
  GEN_CTA_TEST_DRIVE_ACTIVITY_TYPES_ENABLED:
    "generic.cta.testDrive.activityTypes.enabled",
  GEN_CTA_OAB_SERVICE_ACTIVITY_TYPES_ENABLED:
    "generic.cta.oabService.activityTypes.enabled",
  GEN_CTA_NEW_CARS_ACTIVITY_TYPES_ENABLED:
    "generic.cta.newCars.activityTypes.enabled",
  GEN_CTA_USED_CARS_ACTIVITY_TYPES_ENABLED:
    "generic.cta.usedCars.activityTypes.enabled",
  GEN_CTA_GENERIC_CARS_ACTIVITY_TYPES_ENABLED:
    "generic.cta.genericCars.activityTypes.enabled",
  GEN_HIDDEN_FIELDS: "generic.hiddenFields",
  GEN_WHITELIST: "generic.whiteList",
  GEN_BLACKLIST: "generic.blackList",
  GEN_IGNORE_STRICT_GEO: "generic.ignoreStrictGeo",
  GEN_DISABLE_DEALER_NAME_SEARCH: "generic.disableDealerNameSearch",
  GEN_DISABLE_AUTOSUGGEST: "generic.disableAutoSuggest",
  GEN_GEOLOCATION_ON_START: "generic.geolocation.onStart",
  AUTOSUGGEST_HIDE_COUNTRY: "generic.autoSuggest.hideCountry",
  GEN_INITIAL_MAP_ZOOM: "generic.initialMap.zoom",
  GEN_DEALER_MAP_ZOOM: "generic.dealerMap.zoom",
  GEN_INITIAL_MAP_LATITUDE: "generic.initialMap.lat",
  GEN_INITIAL_MAP_LONGITUDE: "generic.initialMap.long",
  ONE_DLC_FORCE_HERE_MAPS: "oneDlc.forceHereMaps",
  ONE_DLC_DEBUG_MODE: "oneDlc.debugMode",
  ONE_DLC_BUILD_DEEPLINK: "oneDlc.buildDeeplink",
  ONE_DLC_SELECT_DEALER_OFFSET: "oneDlc.selectDealerOffset",
  ONE_DLC_SHOW_ALL_DEALERS: "oneDlc.showAllDealers",
  ONE_DLC_INITIAL_FILTER_OPENED: "oneDlc.initialFilterOpened",
  ONE_DLC_DISABLE_MARKER_TOOLTIP: "oneDlc.disableMarkerTooltip",
  ONE_DLC_HIDE_PHONE_DISCLAIMER: "oneDlc.hidePhoneDisclaimer",
  ONE_DLC_HIDE_APPLICANTS: "oneDlc.hideApplicants",
  ONE_DLC_DISABLE_ADDRESS_LINK: "oneDlc.disableAddressLink"
};

const TemplateMarketPropertyFields: Map<string, string> = new Map([
  [TemplateMarketPropertyKeys.ONE_DLC_VIEW_MODE, "View for OneDLC"],
  [
    TemplateMarketPropertyKeys.ONE_DLC_SELECTION_MODE,
    "Dealer selection mode (none, single or multiple)"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_INITIAL_LIST_LOAD,
    "If the DealersList should fetch results on widget load"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_INITIAL_FILTER_ACTIVITY_TYPE,
    "Initial selected activity type filter for OneDLC"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_INITIAL_FILTER_PRODUCT_GROUP,
    "Initial selected product group filter for OneDLC"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_INITIAL_SEARCH_FIELD,
    "Initial search field (locationName, locationId, dealerName)"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_INITIAL_SEARCH_VALUE,
    "Initial search value ('Stuttgart', ln_123sqqeeQ, 'C. Santos')"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_LIST_DEALERS_RESULTS_PER_REQUEST,
    "Number of results per list request (default is 10)"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_LIST_DEALERS_DISABLE_INFINITE_SCROLLING,
    "Disable infinite scrolling for list requests"
  ],
  [
    TemplateMarketPropertyKeys.GEN_IGNORE_STRICT_GEO,
    "Ignore 'StrictGeo' (show dealers without coordinates)"
  ],
  [
    TemplateMarketPropertyKeys.DDW_DEALER_IMAGE_FALLBACK_URL,
    "Dealer fallback image URL"
  ],
  [
    TemplateMarketPropertyKeys.DDW_DEALER_CONTACT_PERSON_IMAGE_FALLBACK_URL,
    "Dealer contact person fallback image URL"
  ],
  [
    TemplateMarketPropertyKeys.DSW_SEARCH_RESULTS_VIEW_MODE,
    "DSW search results view mode"
  ] /* DL-1439 */,
  /*
  [
    TemplateMarketPropertyKeys.DSW_SEARCH_RESULTS_MAX_COUNT,
    'DSW maximum number of search results'
  ],
  */ [
    TemplateMarketPropertyKeys.DSW_SEARCH_RESULTS_PAGINATION_PAGE_SIZE,
    "DSW dealers list pagination: number of dealers per page"
  ],
  /*
  [
    TemplateMarketPropertyKeys.SPA_SEARCH_RESULTS_MAX_COUNT,
    'SPA maximum number of search results'
  ],
  */
  [
    TemplateMarketPropertyKeys.GEN_SEARCH_RADIUS_EXTENDED,
    "Extended / wide radius search"
  ],
  [TemplateMarketPropertyKeys.GEN_SEARCH_RADIUS, "Search radius"],
  [
    TemplateMarketPropertyKeys.GEN_SEARCH_RADIUS_DISTANCE_MIN,
    "Search radius Distance MIN"
  ],
  [
    TemplateMarketPropertyKeys.GEN_SEARCH_RADIUS_DISTANCE_MID,
    "Search radius Distance MID"
  ],
  [
    TemplateMarketPropertyKeys.GEN_SEARCH_RADIUS_DISTANCE_MAX,
    "Search radius Distance MAX"
  ],
  [TemplateMarketPropertyKeys.GEN_DISTANCE_UNIT, "Dealer distance unit"],
  [
    TemplateMarketPropertyKeys.GEN_DISTANCE_DELIMITER,
    "Dealer distance delimiter"
  ],
  [
    TemplateMarketPropertyKeys.GEN_DEALER_NAME_PLACEHOLDER_LINE_1,
    "Dealer name placeholder line 1"
  ],
  [
    TemplateMarketPropertyKeys.GEN_DEALER_NAME_PLACEHOLDER_LINE_2,
    "Dealer name placeholder line 2"
  ],
  [
    TemplateMarketPropertyKeys.GEN_DEALER_NAME_PLACEHOLDER_LINE_3,
    "Dealer name placeholder line 3"
  ],
  [
    TemplateMarketPropertyKeys.GEN_DEALER_ADDRESS_PLACEHOLDER_LINE_1,
    "Dealer address placeholder line 1"
  ],
  [
    TemplateMarketPropertyKeys.GEN_DEALER_ADDRESS_PLACEHOLDER_LINE_2,
    "Dealer address placeholder line 2"
  ],
  [
    TemplateMarketPropertyKeys.GEN_DEALER_ADDRESS_PLACEHOLDER_LINE_3,
    "Dealer address placeholder line 3"
  ],
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_EQC_SALES,
    "Activity types group: EQC sales"
  ],
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_EQC_AFTER_SALES,
    "Activity types group: EQC after sales"
  ],
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_REPAIR,
    "Activity types group: Repair"
  ],
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_JUNGE_STERNE,
    "Activity types group: Junge Sterne Transporter"
  ],
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_COMMERCIAL_SALES,
    "Activity types group: Commercial Sales"
  ],
  [
    TemplateMarketPropertyKeys.GEN_ACTIVITY_TYPE_GROUP_PRIVATE_SALES,
    "Activity types group: Private Sales"
  ],
  [
    TemplateMarketPropertyKeys.GEN_DEALER_PORTFOLIO_ACTIVITY_TYPES_ENABLED,
    "Dealer portfolio: enabled activity types"
  ],
  [
    TemplateMarketPropertyKeys.GEN_DEALER_PORTFOLIO_PRODUCT_GROUPS_ENABLED,
    "Dealer portfolio: enabled product groups"
  ],
  [
    TemplateMarketPropertyKeys.GEN_FILTERS_ACTIVITY_TYPES_ENABLED,
    "Filters: enabled activity types"
  ],
  [
    TemplateMarketPropertyKeys.GEN_FILTERS_PRODUCT_GROUPS_ENABLED,
    "Filters: enabled product groups"
  ],
  [
    TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_AMG,
    "highlighted activity icon mapping : AMG"
  ],
  [
    TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_EQ,
    "highlighted activity icon mapping : EQ"
  ],
  [
    TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_EQ_CHARGER,
    "highlighted activity icon mapping : EQ Charger"
  ],
  [
    TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_PARTS_PRO,
    "highlighted activity icon mapping : PartsPRO"
  ],
  [
    TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_WEBPARTS,
    "highlighted activity icon mapping : WebParts"
  ],
  [
    TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_JUNGE_STERNE,
    "highlighted activity icon mapping : JungeSterne"
  ],
  [
    TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_MB_CERTIFIED,
    "highlighted activity icon mapping : MbCertified"
  ],
  [
    TemplateMarketPropertyKeys.GEN_CTA_TEST_DRIVE_ACTIVITY_TYPES_ENABLED,
    "Dealer CTA TEST DRIVE: enabled activity types"
  ],
  [
    TemplateMarketPropertyKeys.GEN_CTA_OAB_SERVICE_ACTIVITY_TYPES_ENABLED,
    "Dealer CTA OAB SERVICE: enabled activity types"
  ],
  [
    TemplateMarketPropertyKeys.GEN_CTA_NEW_CARS_ACTIVITY_TYPES_ENABLED,
    "Dealer CTA NEW CARS: enabled activity types"
  ],
  [
    TemplateMarketPropertyKeys.GEN_CTA_USED_CARS_ACTIVITY_TYPES_ENABLED,
    "Dealer CTA USED CARS: enabled activity types"
  ],
  [
    TemplateMarketPropertyKeys.GEN_CTA_GENERIC_CARS_ACTIVITY_TYPES_ENABLED,
    "Dealer CTA GENERIC CARS: enabled activity types"
  ],
  [TemplateMarketPropertyKeys.GEN_HIDDEN_FIELDS, "Hidden fields"],
  [TemplateMarketPropertyKeys.ONE_DLC_HIDDEN_FIELDS, "OneDLC Hidden fields"],
  [TemplateMarketPropertyKeys.GEN_WHITELIST, "Dealer Whitelist"],
  [TemplateMarketPropertyKeys.GEN_BLACKLIST, "Dealer Blacklist"],
  [
    TemplateMarketPropertyKeys.GEN_DISABLE_AUTOSUGGEST,
    "Disable Autosuggeestions on Dealer Search"
  ],
  [
    TemplateMarketPropertyKeys.GEN_DISABLE_DEALER_NAME_SEARCH,
    "Disable DealerName search, removing the tabs component"
  ],
  [
    TemplateMarketPropertyKeys.AUTOSUGGEST_HIDE_COUNTRY,
    "Hide country in location suggestions"
  ],
  [
    TemplateMarketPropertyKeys.GEN_GEOLOCATION_ON_START,
    "Automatically asks for user location when application starts"
  ],
  [
    TemplateMarketPropertyKeys.GEN_DEALER_MAP_ZOOM,
    "Dealer Card - Dealer Map zoom"
  ],
  [TemplateMarketPropertyKeys.GEN_INITIAL_MAP_ZOOM, "Initial map zoom"],
  [
    TemplateMarketPropertyKeys.GEN_INITIAL_MAP_LATITUDE,
    "Initial map latitude (longitude also needs to be set) - x.xxx"
  ],
  [
    TemplateMarketPropertyKeys.GEN_INITIAL_MAP_LONGITUDE,
    "Initial map longitude (latitude also needs to be set) - -x.xxx"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_USE_MARKERS_AVERAGE,
    "Use average central point from available markers"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_FORCE_HERE_MAPS,
    "Force HereMaps map rendering"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_DEBUG_MODE,
    "Enable debug mode (console will log actions)"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_BUILD_DEEPLINK,
    "Enable generate deeplink on dealer select"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_SELECT_DEALER_OFFSET,
    "Vertical offset when selecting a dealer"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_SHOW_ALL_DEALERS,
    "Enable show all dealers button on deeplink view"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_INITIAL_FILTER_OPENED,
    "Search filter opened by default"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_DISABLE_MARKER_TOOLTIP,
    "Disable markers tooltip on hover"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_HIDE_PHONE_DISCLAIMER,
    "Hide phone disclaimer on Dealer Card"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_HIDE_APPLICANTS,
    "Hide dealers with applicant status"
  ],
  [
    TemplateMarketPropertyKeys.ONE_DLC_DISABLE_ADDRESS_LINK,
    "Disable route link on Dealer address"
  ]
]);

export default TemplateMarketPropertyFields;
